import { render, staticRenderFns } from "./Time.vue?vue&type=template&id=85038ec4&scoped=true"
import script from "./Time.vue?vue&type=script&lang=ts"
export * from "./Time.vue?vue&type=script&lang=ts"
import style0 from "./Time.vue?vue&type=style&index=0&id=85038ec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85038ec4",
  null
  
)

export default component.exports